import { useEffect, useRef } from 'react';
import { mountScript, removeScript } from './useScript';

const useThreadMetrix = (id: any, token: any) => {
  const previousToken = useRef();
  const previousScript = useRef('');
  const threadMetrix = 'h.online-metrix.net/fp/tags.js';

  useEffect(() => {
    if (!id || !token || previousToken.current) {
      return;
    }
    if (previousScript.current) {
      removeScript(previousScript.current);
    }
    const scriptURL = `https://${threadMetrix}?org_id=${id}&session_id=${token}`;
    mountScript(scriptURL);
    previousToken.current = token;
    previousScript.current = scriptURL;
  }, [token, previousToken]);
};

export default useThreadMetrix;
